import { SafeUrl } from '@angular/platform-browser';

export const convertSafeUrlToBlob = (safeUrl: SafeUrl): Promise<Blob> => {
  return fetch(safeUrl.toString()).then((response) => response.blob());
};
